export default {
  PREVIOUS_PAGE_URL: "previous-page-url",
  CURRENT_PAGE_URL: "current-page-url",

  REF_ENTER_ADD_GROUP_SITE_PUBLISHER: "ref-enter-add-group-site-publisher",
  REF_ENTER_ADD_GROUP_SITE_PUBLISHER_VALUE_ADD_CAMPAIGN: "add-campaign",
  REF_ENTER_ADD_GROUP_SITE_PUBLISHER_VALUE_ADD_GROUP: "add-group",
};
